export default {
  props: {
    chiefComplaints: Array,
    otherComplaints: Array,
  },
};
